import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_OFFER_BY_ID = gql`
  query RookieOfferById($offerId: Int!, $timeSlotId: Int!) {
    rookieOfferById(offerId: $offerId, timeSlotId: $timeSlotId) {
      id
      shortCode
      remainingSlots
      provider {
        id
        uuid
        name
        description

        companyBenefits {
          id
          name
        }

        locations {
          id
          name
          address {
            street
            number
            addressCity {
              id
              name
              zip
            }
          }
        }
        companyProfilePicture {
          id
          name
          image {
            ...imageFields
          }
        }
      }
      workTime
      workClothes
      job {
        id
        bicID
        name
        description
        videoUrl
        jobSalary {
          entries {
            salaryType
            salaryFrom
            salaryTo
          }
        }
        scholasticDuration {
          durationName
          position
        }
        interestFields {
          id
          interestName
        }
      }
      additionalEntries {
        id
        remainingSlots
        job {
          id
          name
        }
        provider {
          id
          uuid
          name
          locations {
            id
            name
            address {
              street
              number
              addressCity {
                id
                name
              }
            }
          }
          companyProfilePicture {
            id
            name
            image {
              ...imageFields
            }
          }
        }
      }

      timeSlotMappingsSimple {
        id
        timeSlot {
          id
          name
          state
          openAt
          closeAt
          workFrom
          workTo
        }
      }
    }
  }
  ${ImageFragment}
`;
